<!--
 * @Author: Pluto 66291979@qq.com
 * @Date: 2024-06-05 14:40:08
 * @LastEditors: pluto.guo 66291979@qq.com
 * @LastEditTime: 2025-03-12 15:03:44
 * @FilePath: /lobby/src/components/GameCard.vue
 * @Description: 
 * 
 * Copyright (c) 2024 by ${git_name_email}, All Rights Reserved. 
-->
<template>
  <div :class="isBig ? 'big-continer' : 'min-continer'">
    <div
      v-if="isBig && game"
      class="big-card"
      :style="`background-image: url(${getCover(game.cover)})`"
      @click="onGame"
    >
      <div class="list_collect" @click.stop="onCollect">
        <i :class="`bi bi-suit-heart-fill ${iscollect ? 't_red' : ''}`"></i>
      </div>
      <div v-if="!getIcon()" :class="`list_tab ${getColor()}`">
        {{ game.tag[0] }}
      </div>
      <div class="jackpots" v-if="game && game.jackpots && parseFloat(game.jackpots) > 0">
        <span style="font-weight: 700">JP</span>&nbsp;&nbsp;{{ formatMoney(game.jackpots) }}
      </div>
      <div class="big">
        <div style="font-size: 0.18rem; color: #00cf34">
          <i class="bi bi-people-fill"></i
          ><span style="color: white; line-height: 0.2rem; opacity: 0.75"
            >&nbsp;{{ formatMoney(person, 0) }}</span
          >
        </div>
        <span :style="`opacity: 0.75; padding: 0 10%; font-size: ${getNameSize(game.name)}`">{{
          game.name
        }}</span>
      </div>
      <div :class="`game_name_big ${getBackgroundColor(game.backColor)}_big`"></div>
    </div>
    <div
      v-else-if="!isBig && game"
      class="card"
      :style="`height: ${height}rem;background-image: url(${getCover(game.cover)})`"
      @click="onGame"
    >
      <div class="list_collect" @click.stop="onCollect">
        <i :class="`bi bi-suit-heart-fill ${iscollect ? 't_red' : ''}`"></i>
      </div>
      <div v-if="!getIcon()" :class="`list_tab ${getColor()}`">
        {{ game.tag && game.tag[0] ? game.tag[0] : '' }}
      </div>
      <div class="jackpots" v-if="game && game.jackpots && parseFloat(game.jackpots) > 0">
        <span style="font-weight: 700">JP</span>&nbsp;&nbsp;{{ formatMoney(game.jackpots) }}
      </div>
      <div class="big" style="font-size: 0.3rem; line-height: 0.3rem">
        <div style="font-size: 0.18rem; color: #00cf34">
          <i class="bi bi-people-fill"></i
          ><span style="color: white; line-height: 0.2rem; opacity: 0.75"
            >&nbsp;{{ formatMoney(person, 0) }}</span
          >
        </div>
        <!-- <span style="padding: 0 5%">{{ game.name }}</span> -->
        <span :style="`opacity: 0.75; padding: 0 10%; font-size: ${getNameMinSize(game.name)}`">{{
          game.name
        }}</span>
      </div>
      <div :class="`game_name ${getBackgroundColor(game.backColor)}`"></div>
      <div
        v-if="game.needRecharge && rechargeCount < 1"
        :class="from == 'bonusGames' ? 'lock-mask' : 'lock-mask-other'"
      >
        <div class="mask" />
        <i class="bi bi-lock" style="z-index: 6"></i
        ><span
          style="
            width: 100%;
            font-size: 0.22rem;
            z-index: 6;
            text-align: center;
            margin-left: -0.15rem;
          "
          >{{ $t('bonus.unlock') }}</span
        >
      </div>
    </div>
    <div v-else style="background-color: black" :class="isBig ? 'big-card' : 'card'" />
    <div
      v-if="isBig && game && getIcon()"
      class="tag_icon"
      :style="`background-image: url(${getIcon()})`"
    />
    <div
      v-else-if="!isBig && game && getIcon()"
      class="tag_icon_min"
      :style="`background-image: url(${getIcon()})`"
    />
  </div>
</template>

<script>
import { config } from '@/common/config'
import { BUS, POPUP } from '@/event/EventCenter'
import { useLobbyStore } from '@/stores/lobby'
import { useUserStore } from '@/stores/user'
import { formatMoney, getRandomIntInclusive, splitText } from '@/utils/helper'
import { mapActions, mapState } from 'pinia'
import { showSuccessToast, showToast } from 'vant'
export default {
  name: 'LobbyGameCard',
  props: {
    game: {
      type: Object,
      default: null
    },
    isBig: {
      type: Boolean,
      default: false
    },
    height: {
      type: String,
      default: '2.43'
    },
    from: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      iscollect: false,
      resBaseUrl: config.resBaseUrl,
      isHot: false,
      person: 0
    }
  },

  mounted() {
    this.iscollect = (this.game && this.game.isCollect) || false
    if (this.game && this.game.category && this.hotGame) {
      this.isHot = this.game.category.includes(this.hotGame.id)
      this.randomPerson()
    }
  },
  computed: {
    ...mapState(useUserStore, ['isLogin', 'rechargeCount']),
    ...mapState(useLobbyStore, ['categories', 'hotGame'])
  },
  methods: {
    splitText,
    formatMoney,
    getRandomIntInclusive,
    ...mapActions(useLobbyStore, {
      enterGame: 'enterGame',
      favorite: 'favorite',
      updatecollectGameId: 'updatecollectGameId'
    }),
    randomPerson() {
      const now = new Date()
      const hours = now.getHours()
      const minutes = now.getMinutes()
      const isInRange = (hours > 16 || (hours === 16 && minutes >= 30)) && hours < 24
      let initialValue = 0
      const getRandomValue = (min, max, changeMin, changeMax, limitMin, limitMax) => {
        initialValue = initialValue === 0 ? getRandomIntInclusive(min, max) : initialValue
        const changeValue = getRandomIntInclusive(changeMin, changeMax)
        return Math.min(
          Math.max(initialValue + changeValue * [1, -1][getRandomIntInclusive(0, 1)], limitMin),
          limitMax
        )
      }

      const getPersonValue = () => {
        if (isInRange) {
          this.person = this.isHot
            ? getRandomValue(3000, 5000, 5, 20, 2000, 6000)
            : getRandomValue(2000, 3000, 5, 15, 1000, 4000)
        } else {
          this.person = this.isHot
            ? getRandomValue(3000, 5000, 5, 20, 2000, 6000) * 0.6
            : getRandomValue(2000, 3000, 5, 15, 1000, 4000) * 0.6
        }
        // initialValue = this.person
      }
      getPersonValue()
      setInterval(() => {
        getPersonValue()
      }, 30000)
    },
    onCollect() {
      if (!this.isLogin) {
        this.updatecollectGameId(this.game.gameId)
        this.$bus.$emit(BUS.SHOW_POPUP, { from: 'collect', to: POPUP.LOGIN, show: true })
      } else {
        this.iscollect = !this.iscollect
        this.favorite(this.game.gameId, this.iscollect)
        // console.log('-=-=-=-=-=-=-=-=-=-=--')
        if (this.iscollect) {
          showSuccessToast({
            message: this.$t('common.collect'),
            wordBreak: 'break-word',
            className: 'toast_success_40',
            duration: 3000
          })
        } else {
          showToast({ message: this.$t('common.uncollect'), duration: 3000 })
        }
      }
    },
    getNameSize(name) {
      const len = name.length
      // console.log(len)
      if (len > 30) {
        return '0.3rem'
      } else if (len > 25) {
        return '0.33rem'
      } else if (len > 15) {
        return '0.36rem'
      } else {
        return '0.4rem'
      }
    },
    getNameMinSize(name) {
      const len = name.length
      // console.log(len)//
      if (len > 30) {
        return '0.16rem'
      } else if (len > 25) {
        return '0.18rem'
      } else if (len > 22) {
        return '0.24rem'
      } else {
        return '0.3rem'
      }
    },
    onGame() {
      if (!this.game) {
        return
      }
      if (this.isLogin) {
        if (this.game.needRecharge && this.rechargeCount < 1) return
        this.enterGame(parseInt(this.game.gameId)).then((response) => {
          this.$router.push({ name: 'gameView', params: { currentGameUrl: response.url } })
        })
      } else {
        this.$bus.$emit(BUS.SHOW_POPUP, { from: 'gridListGame', to: POPUP.LOGIN, show: true })
      }
    },
    getIcon() {
      if (this.game.tag && this.game.tag.length > 0) {
        const tag = this.game.tag[0].toUpperCase()
        if (tag == 'NEW') {
          return this.resBaseUrl + 'icon_new.png'
        } else if (tag == 'HOT') {
          return this.resBaseUrl + 'icon_hot.png'
        } else if (tag == 'LIVE') {
          return this.resBaseUrl + 'icon_live.png'
        } else if (tag == 'BONUS GAME') {
          return this.resBaseUrl + 'icon_bonus.png'
        } else {
          return false
        }
      } else {
        return false
      }
    },
    getColor() {
      if (this.game.tag && this.game.tag.length > 0) {
        const tag = this.game.tag[0].toUpperCase()
        if (tag == 'NEW') {
          return 'green_bg'
        } else if (tag == 'HOT') {
          return 'red_bg'
        } else if (tag == 'EXCLUSIVE') {
          return 'yellow_bg'
        } else if (tag == 'BONUS GAME') {
          return 'gold_bg'
        } else {
          return 'blue_bg'
        }
      }
      return 'blue_bg'
    },
    getBackgroundColor(backColor) {
      var color = ''
      switch (backColor) {
        case 'G':
          color = 'gold_gradient'
          break
        case 'R':
          color = 'red_gradient'
          break
        case 'B':
          color = 'blue_gradient'
          break
        case 'Green':
          color = 'green_gradient'
          break
        case 'Y':
          color = 'yellow_gradient'
          break
        case 'P':
          color = 'purple_gradient'
          break
        default:
          break
      }
      return color
    },
    getCover(url) {
      let imgUrl = `"${url}"`
      return imgUrl
    }
  }
}
</script>

<style lang="scss" scoped>
.big-continer {
  float: left;
  width: 39%;
  margin-bottom: 2%;
  margin-left: 0;
  display: block;
}
.min-continer {
  float: left;
  width: 100%;
  margin-bottom: 2%;
  margin-left: 2%;
  display: block;
}
.big-card {
  float: left;
  width: 100%;
  margin-bottom: 2%;
  margin-left: 0;
  display: block;
  border-radius: 0.16rem 0.16rem 0.16rem 0.16rem;
  overflow: hidden;
  height: 5rem;
  background-repeat: no-repeat;
  background-position-x: center;
  background-size: 125% auto;
}

.card {
  float: left;
  width: 100%;
  margin-bottom: 2%;
  margin-left: 2%;
  display: block;
  border-radius: 0.16rem 0.16rem 0.16rem 0.16rem;
  overflow: hidden;
  height: 2.43rem;
  background-repeat: no-repeat;
  background-position-x: center;
  background-size: 100% auto;
}

.big {
  display: flex;
  flex-direction: column-reverse;
  justify-content: flex-start;
  width: 100%;
  height: 100%;
  line-height: 0.4rem;
  font-size: 0.4rem;
  font-weight: bold;
  font-family: 'Droid Sans', Roboto, Arial, sans-serif;
  color: #fff;
  text-shadow: 0 0 0.06rem rgba(0, 0, 0, 0.6);
  word-wrap: break-word;
  position: relative !important;
  margin-bottom: -205% !important;
  text-align: center;
  z-index: 5;
}

.lock-mask {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 33%;
  height: 100%;
  position: absolute;
  top: 0;
  color: #fff;
  font-size: 1rem;

  .mask {
    background: rgba(0, 0, 0, 0.6);
    width: 100%;
    height: 100%;
    position: absolute;
    z-index: 5;
  }
}

.lock-mask-other {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 100%;
  height: 100%;
  position: relative;
  top: -100%;
  color: #fff;
  // z-index: 99;
  font-size: 1rem;

  .mask {
    background: rgba(0, 0, 0, 0.6);
    width: 105%;
    height: 105%;
    position: absolute;
    margin-top: 0px;
    z-index: 5;
  }
}

.t_red {
  color: #ff0000 !important;
}

.red_bg {
  background-color: #f00;
}

.green_bg {
  background-color: #00ab40;
}

.yellow_bg {
  background-color: #ffbe00;
}

.gold_bg {
  background-color: #836136;
}

.blue_bg {
  background-color: #0068b7;
}

.game_name_big {
  z-index: 2;
  width: 100%;
  height: 1.6rem;
  text-align: center;
  background-color: rgba(130, 92, 45, 1);
  margin: -0.78rem 0 0 0;
  position: relative;
  display: flex;
}

.game_name {
  z-index: 2;
  height: 1.3rem;
  background-color: rgba(130, 92, 45, 1);
  float: left;
  margin-top: -1.3rem;
  margin-right: 0px;
  margin-bottom: 0px;
  margin-left: 0px;
  position: relative;
  width: 94%;
  padding: 0 3%;
}

.list_tab {
  font-size: 0.18rem;
  line-height: 0.24rem;
  color: #fff;
  text-align: center;
  height: auto;
  width: auto;
  padding-right: 0.1rem;
  padding-left: 0.1rem;
  border-radius: 0 0.1rem 0.1rem 0;
  float: left;
  position: relative;
  z-index: 4;
  display: inline;
  box-shadow: 0px 2px 0px rgba(0, 0, 0, 0.4);
  margin-bottom: -0.24rem;
}

.tag_icon {
  width: 0.64rem;
  height: 0.58rem;
  background-size: 100%;
  background-repeat: no-repeat;
  position: relative;
  margin-top: -0.1rem;
}

.tag_icon_min {
  width: 0.64rem;
  height: 0.58rem;
  background-size: 100%;
  background-repeat: no-repeat;
  position: relative;
  z-index: 5;
  margin-top: -0.2rem;
  margin-left: -0.1rem;
  // margin-right: 21%;
}

.list_collect {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.5);
  float: right;
  width: 0.38rem;
  height: 0.28rem;
  padding-top: 0.05rem;
  margin-top: -0.4rem;
  border-radius: 50%;
  position: relative;
  text-align: center;
  z-index: 10;
  bottom: -0.45rem;
  right: 0.05rem;

  i {
    font-size: 0.24rem;
    color: #999999;
  }
}

.jackpots {
  display: flex;
  justify-content: center;
  align-content: center;
  width: 50%;
  height: 0.2rem;
  line-height: 0.2rem;
  background: rgba(0, 0, 0, 0.5);
  border-radius: 0.14rem;
  font-size: 0.16rem;
  padding: 0.03rem 0.05rem;
  margin: 0.1rem 25% -0.4rem 25%;
  color: #ffffff;
}

.gold_gradient_big {
  width: 100%;
  height: 1.6rem;
  margin-top: 150%;
  background-color: rgba(130, 92, 45, 1);
  background: linear-gradient(
    to bottom,
    #ceb45f00,
    #ceb45fcc 30%,
    #ceb45f 42%,
    #aa884a 70%,
    #825c2d 96%
  );
}

.red_gradient_big {
  width: 100%;
  height: 1.6rem;
  margin-top: 150%;
  background-color: rgba(213, 65, 0, 1);
  background: linear-gradient(
    to bottom,
    rgba(213, 65, 0, 0),
    rgba(213, 65, 0, 0.5) 20%,
    rgba(213, 65, 0, 1) 45%
  ) !important;
}

.blue_gradient_big {
  width: 100%;
  height: 1.6rem;
  margin-top: 150%;
  background-color: rgba(213, 65, 0, 1);
  background: linear-gradient(to bottom, #003f8000, #003f8080 20%, #003f80 45%) !important;
}

.green_gradient_big {
  width: 100%;
  height: 1.6rem;
  margin-top: 150%;
  background-color: rgba(9, 124, 37, 1);
  background: linear-gradient(
    to bottom,
    rgba(9, 124, 37, 0),
    rgba(9, 124, 37, 0.5) 20%,
    rgba(9, 124, 37, 1) 40%
  ) !important;
}

.yellow_gradient_big {
  width: 100%;
  height: 1.6rem;
  margin-top: 150%;
  background-color: rgba(255, 141, 0, 1);
  background: linear-gradient(
    to bottom,
    rgba(255, 141, 0, 0),
    rgba(255, 141, 0, 0.5) 20%,
    rgba(255, 141, 0, 1) 40%
  ) !important;
}

.purple_gradient_big {
  width: 100%;
  height: 1.6rem;
  margin-top: 150%;
  background-color: rgba(161, 0, 170, 1);
  background: linear-gradient(
    to bottom,
    rgba(161, 0, 170, 0),
    rgba(161, 0, 170, 0.5) 20%,
    rgba(161, 0, 170, 1) 40%
  ) !important;
}

.gold_gradient {
  width: 100%;
  height: 1.3rem;
  margin-top: 58%;
  background-color: rgba(130, 92, 45, 1);
  background: linear-gradient(
    to bottom,
    rgba(206, 180, 95, 0),
    rgba(206, 180, 95, 0.6) 30%,
    rgba(206, 180, 95, 0.8) 50%,
    rgba(170, 136, 74, 0.9) 70%,
    rgba(130, 92, 45, 1) 95%
  );
}

.red_gradient {
  width: 100%;
  height: 1.3rem;
  margin-top: 58%;
  background-color: rgba(213, 65, 0, 1);
  background: linear-gradient(
    to bottom,
    rgba(213, 65, 0, 0),
    rgba(213, 65, 0, 0.6) 50%,
    rgba(213, 65, 0, 1) 95%
  ) !important;
}

.blue_gradient {
  width: 100%;
  height: 1.3rem;
  margin-top: 58%;
  background-color: rgba(0, 63, 128, 1);
  background: linear-gradient(
    to bottom,
    rgba(0, 63, 128, 0),
    rgba(0, 63, 128, 0.6) 50%,
    rgba(0, 63, 128, 1) 95%
  ) !important;
}

.green_gradient {
  width: 100%;
  height: 1.3rem;
  margin-top: 58%;
  background-color: rgba(9, 124, 37, 1);
  background: linear-gradient(
    to bottom,
    rgba(9, 124, 37, 0),
    rgba(9, 124, 37, 0.6) 50%,
    rgba(9, 124, 37, 1) 95%
  ) !important;
}

.yellow_gradient {
  width: 100%;
  height: 1.3rem;
  margin-top: 58%;
  background-color: rgba(255, 141, 0, 1);
  background: linear-gradient(
    to bottom,
    rgba(255, 141, 0, 0),
    rgba(255, 141, 0, 0.6) 50%,
    rgba(255, 141, 0, 1) 95%
  ) !important;
}

.purple_gradient {
  width: 100%;
  height: 1.3rem;
  margin-top: 58%;
  background-color: rgba(161, 0, 170, 1);
  background: linear-gradient(
    to bottom,
    rgba(161, 0, 170, 0),
    rgba(161, 0, 170, 0.6) 50%,
    rgba(161, 0, 170, 1) 95%
  ) !important;
}
</style>
